module.exports = {
    au: {
        culture: 'en-AU'
    },
    es: {
        culture: 'es-ES'
    },
    ie: {
        culture: 'en-IE'
    },
    it: {
        culture: 'it-IT'
    },
    nz: {
        culture: 'en-NZ'
    },
    uk: {
        culture: 'en-GB'
    }
};
